export default __webpack_public_path__ + "static/media/leb.d04bf72d.svg";